import React, { useState, useEffect } from "react";
import api from "../Services/api";
import "./busca.css";
import { PulseLoader } from 'halogenium';
import { generatePath, useNavigate } from "react-router-dom";
const ResultadoBusca = (props: any) => {

  const [nextPage, setNextPage] = useState<any[]>([]);
  const [result, setResult] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadmore, setLoadmore] = useState(false);
  const [pageSize, setPageSize] = useState(0);

  let notFound = false;

  let navigate = useNavigate();

  var search = window.location.search.substring(3);
  search = search.replace(/\+/g, " ");
  search = search.replace("mobile=", "");

  document.title = "Busca"

  useEffect(() => {
    api
      .get("/PesquisarNoticiasPublicacoes?Pesquisa=" + search)
      .then((response) => {

        processJson(response.data.query.PrimaryQueryResult.RelevantResults.Table.Rows.results);

      })
      .catch((err) => {
        //throw new Error(err);
        // processJson(mock.query.PrimaryQueryResult.RelevantResults.Table.Rows.results);
      });


    function processJson(data: any) {

      let result: { Title: string; Url: string; Description: string; highlight: string; Path: string; }[] = [];

      for (let i = 0; i < data.length; i++) {

        let preObj = { Title: "", Url: "", Description: "", highlight: "", Path: "" };

        // /DOCS/Lists/Noticias1/

        data[i].Cells.results.find((item: any) => {
          if (item.Key === "Title") {
            preObj.Title = item.Value;
          }
          return false;
        });
        data[i].Cells.results.find((item: any) => {
          if (item.Key === "Path") {
            preObj.Path = item.Value;
          }
          return false;
        });
        data[i].Cells.results.find((item: any) => {
          if (item.Key === "HitHighlightedSummary") {
            preObj.highlight = item.Value;
          }
          return false;
        });
        if (preObj.Title !== "" || preObj.Path !== "" || preObj.highlight !== "") {
          result.push(preObj);
        }
      }
      // console.log('ddd');
      result.forEach(item => {
        // substituicao dos links do sharepoint se for para Notícias
        if (item.Path.includes('/DOCS/Lists/Noticias')) {
          const url = item.Path;
          const { protocol, hostname, search } = new URL(url);
          const id = search ? search.split('=')[1] : 0;
          item.Path = `${protocol}//${hostname}${Setlocation({Title: item.Title, Id: id}, false)}`;
        }
      });

      managePagination(result);

      setPageSize(result.length);

    }
  }, [search]);

  const Setlocation = (itemPath: any, nav: boolean) => {

    let url = itemPath.Title;
    let Id = itemPath.Id;

    let urlParamTrim = url?.substring(0, 50).normalize("NFD").replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, '-');

    if (urlParamTrim === undefined || urlParamTrim == null) {
      urlParamTrim = "Noticias...";
    } else {
      urlParamTrim = urlParamTrim + "...";

    }
    var searchParams = new URLSearchParams(urlParamTrim);
    searchParams.set("Id", Id);
    var path = "/noticias-internas/" + searchParams.toString();
    if (nav) {
      navigate(generatePath(path));
    } else {
      return generatePath(path);
    }
    return url;
  }
  const loadMore = () => {
    setLoading(true);
    setLoadmore(true);
    setTimeout(() => {
      setResult([...result, ...nextPage.slice(0, 6)]);
      setNextPage(nextPage.slice(6));
      if (nextPage.slice(6).length === 0) {
        setLoadmore(false);
      }
      setLoading(false);

    }, 1000);
  }

  function managePagination(data: any) {
    if (data.length > 6) {
      setResult(data.slice(0, 6));
      setNextPage(data.slice(6));
      setLoadmore(true);
    } else {
      setResult(data);

    }
  }

  return (

    <div className="_the-content page-resultado pt-10 mb-8">
      <div className='container'>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="h3">
              Você buscou por <strong className="text-primary"> {decodeURI(search)} </strong> <br />
              <strong className="text-primary"> {pageSize} </strong> resultados foram <span className="d-block d-lg-inline-block"> encontrados.<strong className="text-primary">   </strong>   </span>
            </h2>
            <hr className="mt-8 mb-5" />


            <div id="searchresultsarea" className="tabs active " data-tab="noticias">
              <div className='row'>

                {result?.map((item, index) => (

                  <div key={index} className="searchresult load-post" >
                    <div className="card-noticia px-lg-4 border   pt-5 pt-lg-0">
                      <div className="card-div-search">
                        <a href={item.Path} target="_blank" rel="noreferrer"><h2>{item.Title}</h2></a>

                        <a className="link-search" href={item.Path} target="_blank" rel="noreferrer">{item.Path}</a>
                      </div>

                      <div className="link-p" >{item.highlight.replace(/<c0>/g, '').replace(/<\/c0>/g, '').replace(/<ddd>/g, '').replace(/<ddd\/>/g, '')}</div>
                    </div>
                  </div>
                ))}

              </div>

            </div>
            {loading && <div className="container" id="loading" style={{ position: "relative", left: "35%" }}>
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="tabs mb-6 pt-8">
                    <div className='row align-items-strech'>
                      <PulseLoader size={20} color="#E87400" margin="4px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>}
            {notFound === false && loadmore && loading === false && <div style={{ position: "relative" }}> <button id="loadMore" style={{ position: "absolute", left: "50%", top: "45px", msTransform: "translate(-50%, -50%)", transform: "translate(-50%, -50%)" }} className="btn btn-primary py-4 px-5 rounded" onClick={() => loadMore()}>Carregar mais</button></div>}
            <br /><br />
            {notFound && <div className="container" id="notFound" style={{ position: "relative", left: "1%" }}>
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="tabs mb-6 pt-8">
                    <div className='row align-items-strech'>
                      <h3>Oops! Não encontramos nada.</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>}

          </div>
        </div>
      </div>
    </div>
  )

};

export default ResultadoBusca;